import React from "react";
import Image from "components/image";
import useToggle from "hooks/useToggle";
import CatalogModal from "./modal";

const CatalogPromo = ({ data }) => {
	const [isModalOpen, toggleModal] = useToggle();
	const { title, subtitle, form, buttonText, image } = data;

	const handleToggleModal = (event) => {
		event.preventDefault();
		event.stopPropagation();
		toggleModal();
	};

	return (
		<div className="py-4 md:py-8 flex flex-col-reverse md:flex-row justify-center items-center gap-10">
			<CatalogModal data={form} isOpen={isModalOpen} toggle={toggleModal} />
			<div>
				<h2>{title}</h2>
				<div className="pt-4 pb-8 md:pb-12">
					<span className="text-gray-500">{subtitle}</span>
				</div>
				<button onClick={handleToggleModal} className="btn-secondary t-catalog-download-now">{buttonText}</button>
			</div>
			<div>
				<Image image={image} />
			</div>
		</div>
	);
};

export default CatalogPromo;